import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog } from "@mui/material";
import { useSelector } from "react-redux";
const Modal = ({ children, open, close, title, autoWidth = false , noPadding = false }) => {
  const { themeColor } = useSelector((state) => state.themeColor);

  return (
    <Dialog
      sx={{
        ".MuiPaper-root": {
          maxWidth: autoWidth ? "initial !important" : "600px",
          marginY: { md: "12px !important", xs: "0 !important" },
          width: { md: "auto", xs: "95%" },
        },
      }}
      onClose={close}
      open={open}
      dir="rtl"
    >
      <Box
        sx={{
          px: {
            md: 5,
            xs: 1,
          },
          pt: 2,
        }}
        className={`flex justify-between items-center mb-7 pb-1 w-full border-b md:border-0 `}
      >
        <Box className="text-base md:text-lg  font-bold">{title}</Box>
        <Box
          className=" justify-center items-center cursor-pointer"
          sx={{
            background: "#d32f2f",
            width: "25px",
            height: "25px",
            borderRadius: "50%",
            display: "flex",
          }}
          onClick={close}
        >
          <CloseIcon sx={{ color: "#fff" }} />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          justifyContent: "center",
          px: { md: noPadding ? 0:  3  , xs: 1 },
          pb: 2,
          minWidth: { md: "420px", xs: "98%" },
        }}
        className={`${themeColor === "dark" ? "darkMode" : ""}`}
      >
        {children}
      </Box>
    </Dialog>
  );
};

export default Modal;
